import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RivisionsTable from "./revisionsTable";

const Table = ({ record, mcPermissions }) => {
  const [statusOptions, setStatusOptions] = useState([]);
  const { allRevisionStatuses } = useSelector(
    (state) => state.revisionStatusReducer
  );

  // useEffect(() => {
  //   let updatedStatuses = allRevisionStatuses.map((el) => {
  //     const { status_name, id } = el;
  //     return { value: id, label: status_name };
  //   });
  //   setStatusOptions(updatedStatuses);
  // }, [allRevisionStatuses]);

  return (
    <RivisionsTable
      record={record}
      parentRecordID={record.id}
      uniqueId={record.uniqueId}
      type={record.type}
      orgRecordId={record.projectId}
      mcPermissions={mcPermissions}
    />
  );
};

export default Table;
